import React from "react";
import 'dygraphs/dist/dygraph.min.css'
import HistogramContainer from "./HistogramContainer";
import {Button, OverlayTrigger, Stack, Tooltip, Form} from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import { CSVLink} from "react-csv";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import tableDataModules from "../../controller/tableDataModules";

export default class HistogramComponent extends React.Component{

    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.percentages = [];

        this.state = {histoData: [],labels: [],organs: [],loaded: false,
            optionStudents: ['*'],
            optionSessions: ['*'],
            optionYears: ['*'],
            optionOrganGS: '',
            optionOrganST: '',
            optionAbsolute: true,
            separateGSOrgan: false, // Toggle for separate GS organ selection
            caseData: {},
            statistics: {
                selected: {},
                all: {}
            }
        };
    }


    componentDidMount() {
        axios.get('/api/percentiles/from/case/'+this.props.case)
            .then((response) => {
                if (response.status !== 200) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                return response.data;
            })
            .then((json) => {
                const organs = {};
                if(json.length > 0){
                    for (let i = 0; i < json.length; i++) {
                        for (const perc of json[i].percentiles) {
                            organs[perc.a] = true;
                        }
                    }
                }
                const labelArray = [];
                if(this.props.showST){
                    if(this.props.showST){
                        const stObj = json.filter((ob) => ob.studentNumber === this.props.showST);
                        if(stObj.length > 0){
                            json = [stObj[0]];
                            labelArray.push(stObj[0].studentNumber)
                        }
                        console.log(stObj)
                    }
                }else{
                    for (const dataJson of json) {
                        labelArray.push(dataJson.studentNumber);
                    }
                }


                const objOrg = Object.keys(organs);
                this.setState({histoData: json,labels: labelArray,organs: objOrg,optionOrganGS: objOrg[0],optionOrganST: objOrg[0],loaded: true})
            })
            .catch((err) => console.error(`Fetch problem: ${err.message}`));
        tableDataModules.getCaseData(this.props.case).then(res => {
            this.setState({caseData: res})
        });
        this.updateStatistics();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.optionStudents !== this.state.optionStudents ||
            prevState.optionSessions !== this.state.optionSessions ||
            prevState.optionYears !== this.state.optionYears ||
            prevState.optionOrganGS !== this.state.optionOrganGS ||
            prevState.optionOrganST !== this.state.optionOrganST ||
            prevState.optionAbsolute !== this.state.optionAbsolute ||
            prevState.separateGSOrgan !== this.state.separateGSOrgan
        ) {
            this.updateStatistics();
        }
    }

    optionsStudent(){
        return [{value: '*',label: 'All Students'},...this.getUniqueFilterFieldFromHistodata('studentDisplay')]
    }

    optionsSession(){
        return [{value: '*', label: 'All Sessions'}, ...this.getUniqueFilterFieldFromHistodata('sessionIndex')]
    }

    optionsYear(){
        return [{value: '*', label: 'All Years'}, ...this.getUniqueFilterFieldFromHistodata('year')]
    }

    getUniqueFilterFieldFromHistodata(filterName){
        let unify = {};
        for (const histoDatum of this.state.histoData) {
            unify[histoDatum[filterName]] = true;
        }
        return this.getOptionsFromArray(Object.keys(unify));
    }

    getOptionsFromArray(array){
        const option = [];
        for (const key of array) {
            option.push({value: key,label: key});
        }
        return option;
    }
    histogramDataGenerator(addFirstRow = false, specificOrganGS = null, specificOrganST = null, useFilters = true) {
        const dataArray = [];
        const organGS = specificOrganGS || this.state.optionOrganGS;
        const organST = specificOrganST || this.state.optionOrganST;

        if (addFirstRow) {
            let headerRow = ["Percentile"];
            for (const argument of this.state.histoData) {
                headerRow.push(argument.studentNumber);
            }
            dataArray.push(headerRow);
        }

        for (let i = 0; i < 101; i++) {
            const percentileRow = [i];
            for (const argument of this.state.histoData) {

                if(useFilters){
                    if (!this.state.optionStudents.includes('*') && !this.state.optionStudents.includes(argument.studentDisplay + ''))
                        continue;
                    if (!this.state.optionSessions.includes('*') && !this.state.optionSessions.includes(argument.sessionIndex + ''))
                        continue;
                    if (!this.state.optionYears.includes('*') && !this.state.optionYears.includes(argument.year + ''))
                        continue;
                }

                let percentileValue = NaN;
                for (const percentile of argument.percentiles) {
                    if (percentile.p === i) {
                        if (percentile.a === organGS && percentile.b === organST) {
                            percentileValue = this.state.optionAbsolute ? percentile.vAbs : percentile.v;
                            if ((this.state.optionAbsolute && percentileValue === 128) || (!this.state.optionAbsolute && percentileValue === -128)) {
                                percentileValue = NaN;
                            }
                            break;
                        }
                    }
                }

                if (isNaN(percentileValue)) {
                    for (let j = i; j > 0; j--) {
                        if (dataArray[j] && !isNaN(dataArray[j][percentileRow.length])) {
                            percentileValue = dataArray[j][percentileRow.length];
                            break;
                        }
                    }
                }
                percentileRow.push(percentileValue);
            }
            dataArray.push(percentileRow);
        }

        return dataArray;
    }


    calculateStatistics(data) {
        const values = data.flat().filter(v => !isNaN(v) && typeof v === 'number');
        values.sort((a, b) => a - b);
        const len = values.length;

        return {
            gemiddelde: values.reduce((sum, val) => sum + val, 0) / len,
            mediaan: len % 2 === 0 ? (values[len/2 - 1] + values[len/2]) / 2 : values[Math.floor(len/2)],
            eerstekwartiel: values[Math.floor(len / 4)],
            derdekwartiel: values[Math.floor(3 * len / 4)],
            percentiel95: values[Math.floor(0.95 * len)]
        };
    }

    updateStatistics() {
        const selectedData = this.histogramDataGenerator().slice(1).map(row => row.slice(1));
        const allData = this.histogramDataGenerator(false, null, null, false).slice(1).map(row => row.slice(1));

        this.setState({
            statistics: {
                selected: this.calculateStatistics(selectedData),
                all: this.calculateStatistics(allData)
            }
        });
    }


    generateZipFile = () => {
        const zip = new JSZip();

        // Iterate over each combination of organGS and organST
        this.state.organs.forEach(gs => {

                // Generate the CSV data for each organGS and organST combination
                const data = this.histogramDataGenerator(true, gs, gs);
                const csvData = data.map(row => row.join(',')).join('\n');
                const fileName = `${gs}.csv`;
                zip.file(fileName, csvData);

        });

        // Generate the zip file asynchronously
        zip.generateAsync({ type: "blob" })
            .then(content => {
                saveAs(content, `histograms_${this.state.caseData.name}.zip`);
            })
            .catch(err => console.error("Error generating ZIP file:", err));
    };

    getAbsOption(){
        return [
            {value: true,label: 'Unsigned'},
            {value: false,label: 'Signed'}
        ];
    }


    getValuesFromOption(option){
        const values=[];
        for (const opt of option) {
            values.push(opt.value)
        }
        return values;
    }

    handleObserverOrganChange = (selectedOption) => {
        const organValue = selectedOption.value;
        if (this.state.separateGSOrgan) {
            // Only change observer organ when separate mode is enabled
            this.setState({ optionOrganST: organValue });
        } else {
            // Change both organs when separate mode is disabled
            this.setState({ 
                optionOrganST: organValue,
                optionOrganGS: organValue 
            });
        }
    }

    handleGSOrganChange = (selectedOption) => {
        // Only available when separate mode is enabled
        this.setState({ optionOrganGS: selectedOption.value });
    }

    handleSeparateModeToggle = (event) => {
        const separateMode = event.target.checked;
        this.setState({ separateGSOrgan: separateMode });
        
        // If disabling separate mode, sync GS organ to match observer organ
        if (!separateMode) {
            this.setState({ optionOrganGS: this.state.optionOrganST });
        }
    }

    render() {
        if(this.state.histoData){
            if(this.state.loaded){
                return (
                    <Stack gap={2} >
                        <Stack gap={2} direction='horizontal' className="mx-auto">
                            <Select placeholder={'Students'} onChange={(e) => this.setState({optionStudents: this.getValuesFromOption(e)})} isSearchable isClearable defaultValue={[this.optionsStudent()[0]]} isMulti options={this.optionsStudent()}/>
                            <Select placeholder={'Session'} onChange={(e) => this.setState({optionSessions: this.getValuesFromOption(e)})} isSearchable isClearable defaultValue={[this.optionsSession()[0]]} isMulti options={this.optionsSession()}/>
                            <Select placeholder={'Year'} onChange={(e) => this.setState({optionYears: this.getValuesFromOption(e)})} isSearchable isClearable defaultValue={[this.optionsYear()[0]]} isMulti options={this.optionsYear()}/>
                        </Stack>

                        <Stack gap={2} direction='horizontal' className="mx-auto">
                            <span>Organ Observer: </span>
                            <Select 
                                placeholder={'Observer Organ'} 
                                onChange={this.handleObserverOrganChange} 
                                isSearchable 
                                value={this.getOptionsFromArray(this.state.organs).find(option => option.value === this.state.optionOrganST)}
                                options={this.getOptionsFromArray(this.state.organs)}
                            />
                            
                            <Form.Check 
                                type="switch"
                                id="separate-gs-toggle"
                                label="Separate GS Organ"
                                checked={this.state.separateGSOrgan}
                                onChange={this.handleSeparateModeToggle}
                            />
                            
                            <span>Organ GS: </span>
                            <Select 
                                placeholder={'GS Organ'} 
                                onChange={this.handleGSOrganChange} 
                                isSearchable 
                                isDisabled={!this.state.separateGSOrgan}
                                value={this.getOptionsFromArray(this.state.organs).find(option => option.value === this.state.optionOrganGS)}
                                options={this.getOptionsFromArray(this.state.organs)}
                            />
                            
                            <Select 
                                onChange={(e) => this.setState({optionAbsolute: (e.value)})} 
                                defaultValue={this.getAbsOption()[0]}  
                                options={this.getAbsOption()}
                            />
                        </Stack>
                        <HistogramContainer  data={this.histogramDataGenerator()} labels={this.state.labels}/>
                        <div>
                            <h4>Statistics</h4>
                            <table className="table table-bordered">
                                <thead>
                                <tr>
                                    <th>Data Set</th>
                                    <th>Mean</th>
                                    <th>Median</th>
                                    <th>1st Quartile</th>
                                    <th>3rd Quartile</th>
                                    <th>95th Percentile</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        Selected Data
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="tooltip-selected-data">
                                                    This data is filtered based on the currently selected student filters.
                                                </Tooltip>
                                            }
                                        >
                                            <span className="ms-1 text-info">(i)</span>
                                        </OverlayTrigger>
                                    </td>
                                    <td>{this.state.statistics.selected.gemiddelde?.toFixed(2)}</td>
                                    <td>{this.state.statistics.selected.mediaan?.toFixed(2)}</td>
                                    <td>{this.state.statistics.selected.eerstekwartiel?.toFixed(2)}</td>
                                    <td>{this.state.statistics.selected.derdekwartiel?.toFixed(2)}</td>
                                    <td>{this.state.statistics.selected.percentiel95?.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>All Data</td>
                                    <td>{this.state.statistics.all.gemiddelde?.toFixed(2)}</td>
                                    <td>{this.state.statistics.all.mediaan?.toFixed(2)}</td>
                                    <td>{this.state.statistics.all.eerstekwartiel?.toFixed(2)}</td>
                                    <td>{this.state.statistics.all.derdekwartiel?.toFixed(2)}</td>
                                    <td>{this.state.statistics.all.percentiel95?.toFixed(2)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <Button onClick={this.generateZipFile}>
                            Download All Histograms as ZIP
                        </Button>
                        {this.caseData && (
                            <CSVLink
                                filename={`pan_export_${this.caseData.name}=${this.optionOrganGS}<->${this.optionOrganST}.csv`}
                                data={this.histogramDataGenerator(true)}
                            >
                                <label style={{ textAlign: "center", width: "100%" }}>
                                    Or download currently selected histogram as CSV
                                </label>
                            </CSVLink>
                        )}
                    </Stack>
                );
            }else{
                return <>Loading...</>
            }

        }

    }
}